import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import logo from "assets/images/logo_esg_awards.png";
import BurgerBarMenu from "assets/icons/BurgerBarMenuIcon.js";

function Navbar({ openMenu }) {
  const { t } = useTranslation();
  const dropdownRef = useRef(null);
  const navbarRef = useRef(null);

  const [dropdownOpen, setDropdownOpen] = useState(null);

  const navigation = [
    {
      id: 1,
      label: t("about"),
      elementId: "aboutContainer",
    },
    {
      id: 2,
      label: t("categories"),
      elementId: "categoriesContainer",
    },
    {
      id: 3,
      label: t("judgingProcess"),
      elementId: "judgingProcessContainer",
    },
    {
      id: 4,
      label: t("faq"),
      elementId: "faqContainer",
    },
    {
      id: 5,
      label: t("contact"),
      elementId: "contactContainer",
    },
  ];

  const handleMouseOver = useCallback(
    (e) => {
      if (
        dropdownOpen &&
        !dropdownRef?.current?.contains(e.target) &&
        !navbarRef?.current?.contains(e.target)
      ) {
        setDropdownOpen(null);
      }
    },
    [dropdownOpen, setDropdownOpen]
  );

  const onClickNavbarMenu = (elementId) => {
    const el = document.getElementById(elementId);
    const offset = elementId === "contactContainer" ? -80 : -120;
    const y = el.getBoundingClientRect().top + window.pageYOffset + offset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("mouseover", handleMouseOver);
    return () => {
      window.removeEventListener("mouseover", handleMouseOver);
    };
  }, [handleMouseOver]);

  return (
    <>
      <div
        className={`sticky top-0 shadow-md transition-all z-10 bg-app-navbar`}
      >
        <div
          ref={navbarRef}
          className={`app-nav-container flex justify-between items-center gap-6`}
        >
          <div>
            <a href="/">
              <img src={logo} alt="logo" className="h-16 md:h-30" />
            </a>
          </div>
          <div className={`hidden sm:flex md:space-x-12 text-white font-bold`}>
            <ul className="flex items-center space-x-4 sm:text-sm md:text-base">
              {navigation.map((nav) => {
                if (nav && nav.label === t("contact")) {
                  return (
                    <button
                      key={nav?.id}
                      className="px-3 py-2 ml-4 text-xs text-white uppercase rounded-md bg-[#8DC63F] sm:text-sm sm:px-4 cursor-pointer hover:bg-lime-600"
                      onClick={() => onClickNavbarMenu(nav?.elementId)}
                    >
                      <a
                        className="transition-all duration-300 "
                        href={nav.href}
                        target={nav.target}
                        rel={nav.rel}
                      >
                        {nav.label}
                      </a>
                    </button>
                  );
                } else {
                  return (
                    <li
                      key={nav?.id}
                      onMouseOver={() => setDropdownOpen(nav?.id)}
                      onClick={() => onClickNavbarMenu(nav?.elementId)}
                      className="cursor-pointer"
                    >
                      <a className="pb-1 hover:border-b" href={nav.href}>
                        {nav.label}
                      </a>
                    </li>
                  );
                }
              })}
            </ul>
          </div>
          <button
            className="text-sm font-medium text-white transition-all sm:hidden active:border-b-2 active:border-white"
            onClick={openMenu}
          >
            <BurgerBarMenu
              color="#8DC63F"
              size={32}
              className="cursor-pointer"
            />
          </button>
        </div>
        <div
          ref={dropdownRef}
          className={`absolute left-0 right-0 z-30 shadow-md bg-app-blue-3 ${
            navigation?.[dropdownOpen - 1]?.dropdownNav?.length > 0
              ? "block"
              : "hidden"
          } transition-all`}
        >
          <ul className="grid grid-cols-3 gap-4 py-4 text-white app-main-container lg:py-6">
            {navigation?.[dropdownOpen - 1]?.dropdownNav?.map((nav) => (
              <li
                key={nav?.id}
                onClick={() => onClickNavbarMenu(nav?.elementId)}
              >
                <a
                  className="transition-all duration-300 hover:border-b"
                  href={nav.href}
                >
                  {nav.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}

export default Navbar;
